module.exports = __webpack_public_path__ + "img/img43.5c2e529c.png";